/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Cod_AmountInputs */

const vi_carrier_cod_amount = /** @type {(inputs: Carrier_Cod_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền thu người nhận`)
};

/**

* @param {Carrier_Cod_AmountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_cod_amount = /** @type {((inputs?: Carrier_Cod_AmountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Cod_AmountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_cod_amount(inputs)
});